// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__co78Y","newExpiryDate":"styles_newExpiryDate__3nXSa","footer":"styles_footer__3wpgW"};